// --- 消费统计 --- //

export default [
  {
    name: 'consumptionStatistical',
    path: '/carWashSuperviseSystem/:carWashId/consumptionStatistical',
    meta: { title: '消费统计' },
    component: require('business/carWashSuperviseSystem/consumptionStatistical/list.vue').default
  }
]
